module.exports = __webpack_public_path__ + "img/settings2.73ebf890.svg";